/**
 * Canvas drawing primitives + date formatting shared by the goal-flag plugin
 * (#760, `chart-goal-flags.ts`) and the sim-flag layer (#761,
 * `chart-goal-sim-flags.ts`). Extracted so neither file owns the pixel-drawing
 * details and both stay under the ~300-line guideline.
 */

// Native Intl formatting (date-fns is lint-restricted for non-arithmetic uses,
// #1094) — matches the existing `toLocaleDateString('en-US', {...})` pattern.
export function formatMonthDay(isoDate: string): string {
	return new Date(`${isoDate}T00:00:00`).toLocaleDateString('en-US', {
		month: 'short',
		day: 'numeric'
	});
}

export function formatMonth(isoDate: string): string {
	return new Date(`${isoDate}T00:00:00`).toLocaleDateString('en-US', { month: 'short' });
}

export function drawDiamondMarker(
	c: CanvasRenderingContext2D,
	x: number,
	y: number,
	color: string
): void {
	c.save();
	c.fillStyle = color;
	c.beginPath();
	c.moveTo(x, y - 4);
	c.lineTo(x + 4, y);
	c.lineTo(x, y + 4);
	c.lineTo(x - 4, y);
	c.closePath();
	c.fill();
	c.restore();
}

export function drawPillLabel(
	c: CanvasRenderingContext2D,
	x: number,
	y: number,
	label: string,
	color: string,
	bgColor: string
): void {
	if (!label) return;
	c.save();
	c.font = '500 11px Inter, sans-serif';
	const padX = 6;
	const width = c.measureText(label).width + padX * 2;
	const height = 16;
	const left = c.textAlign === 'right' ? x - width : x - width / 2;
	c.fillStyle = bgColor;
	roundRect(c, left, y - height / 2, width, height, 8);
	c.fill();
	c.fillStyle = color;
	c.textAlign = c.textAlign === 'right' ? 'right' : 'center';
	c.textBaseline = 'middle';
	c.fillText(label, c.textAlign === 'right' ? x - padX : x, y);
	c.restore();
}

function roundRect(
	c: CanvasRenderingContext2D,
	x: number,
	y: number,
	w: number,
	h: number,
	r: number
): void {
	c.beginPath();
	c.moveTo(x + r, y);
	c.arcTo(x + w, y, x + w, y + h, r);
	c.arcTo(x + w, y + h, x, y + h, r);
	c.arcTo(x, y + h, x, y, r);
	c.arcTo(x, y, x + w, y, r);
	c.closePath();
}
